import { useState } from 'react';
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';
import { Container, Kicker, Mark } from './primitives';
import { FeatureVisual } from './FeatureVisuals';
import { FUNZIONALITA } from '@/content/funzionalita';
import { cn } from '@/lib/utils';

/* Le funzionalità come schermate: si sceglie una scheda e si vede BOSS. */
export function FeatureShowcase({ index = '01' }: { index?: string }) {
  const [attiva, setAttiva] = useState(FUNZIONALITA[0].slug);
  const f = FUNZIONALITA.find((x) => x.slug === attiva) ?? FUNZIONALITA[0];

  return (
    <section id="funzionalita" className="relative border-t border-border py-28 md:py-36">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <Kicker index={index} label="Dentro BOSS" />
          <h2 className="boss-display mt-5 text-balance text-[44px] md:text-[72px]">
            La commessa, <Mark>dall’inizio alla fine.</Mark>
          </h2>
        </motion.div>

        <div role="tablist" aria-label="Funzionalità di BOSS" className="mt-10 flex flex-wrap gap-2">
          {FUNZIONALITA.map((x) => (
            <button
              key={x.slug}
              type="button"
              role="tab"
              aria-selected={x.slug === attiva}
              onClick={() => setAttiva(x.slug)}
              className={cn(
                'rounded-full border px-3.5 py-1.5 text-[13px] transition-colors',
                x.slug === attiva
                  ? 'border-primary/40 bg-primary/10 text-foreground'
                  : 'border-border text-fg-2 hover:text-foreground',
              )}
            >
              {x.name}
            </button>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <p className="max-w-2xl text-pretty text-[15px] leading-[1.55] text-fg-2">{f.teaser}</p>
          <Link
            to={`/funzionalita/${f.slug}`}
            className="group shrink-0 text-[14px] text-primary"
          >
            Scopri {f.name.toLowerCase()} <span aria-hidden className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </Link>
        </div>

        <div role="tabpanel" className="mt-8">
          <FeatureVisual key={f.slug} slug={f.slug} />
        </div>
      </Container>
    </section>
  );
}
